import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { PlaningService } from 'app/shared/services/planing/planing.service';
import { Component, Input, OnInit } from '@angular/core';
import { DatatableBaseComponent } from 'app/shared/components/datatable-base.component';
import { Planing } from 'app/shared/models/class/planing/planing';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { ActivatedRoute } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-admin-used-ressource',
  templateUrl: './admin-used-ressource.component.html',
  styleUrls: ['./admin-used-ressource.component.scss']
})
export class AdminUsedRessourceComponent extends DatatableBaseComponent implements OnInit {

  clubCode: any;
  title: string;

  dateForm: UntypedFormGroup;

  planings: Planing[] = [];
  dataSource: MatTableDataSource<Planing>;

  displayedColumns = ['clubRessourcePseudo', 'dateLib', 'offerName', 'sessionStartDate', 'sessionEndDate'];

  isLoading = false;

  userConnected: InfosUser;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  constructor(
    protected uiSrv: UiService,
    private planingSrv: PlaningService,
    private formBuilder: UntypedFormBuilder,
    private faIconService: FaiconService,
    private authService: AuthService,
    private tooltipSrv: TooltipService,
    private route: ActivatedRoute
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.userConnected = this.authService.getDecodedToken();

    this.initComponent();
  }

  private async initComponent() {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = await this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;

    const title = {
      admin: `Liste des ressources utilisées du club : ${this.clubCode}`,
      club: `Liste des ressources utilisées de mon club`
    };

    this.title = title[this.userConnected.role];

    this.isLoading = true;
    this.initSubscriptions();
    this.initForm();
  }

  private initSubscriptions(): void {
    const dateNow = new Date();
    const dateTo = new Date(new Date().setMonth(dateNow.getMonth()+2));
    const dateNowFormated = moment(dateNow).startOf('day').utc().format().toString();
    const dateToFormated = moment(dateTo).endOf('day').utc().format().toString();

    this.addSubscription(
      this.planingSrv.planingListChanged.subscribe(planingsFromSrv => {
        this.isLoading = false;
        this.planings = planingsFromSrv;
        this.initTable();
      })
    );

    this.addSubscription(
      this.planingSrv.getPlaning(this.clubCode, dateNowFormated, dateToFormated).subscribe((planingsFromSrv => {
        this.planings = planingsFromSrv;
      }))
    );

  }

  initForm(): void{
    let dateNow = new Date();
    let dateTo = new Date(new Date().setMonth(dateNow.getMonth()+2));

    this.dateForm = this.formBuilder.group({
      startDate: [dateNow, Validators.required],
      endDate: [dateTo, Validators.required]
    })
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.planings);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = this.planings.length;
    this.isLoading = false;
  }

  onSubmit(): void{
    const formValues = this.dateForm.value;
    const dateNowFormated = moment(formValues.startDate).startOf('day').utc().format().toString();
    const dateToFormated = moment(formValues.endDate).endOf('day').utc().format().toString();
    this.planingSrv.getPlaning(this.clubCode, dateNowFormated, dateToFormated).subscribe()

    this.uiSrv.showSnackbar('Recherche effectuée', false)
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTooltip(value: string): string {
    return this.tooltipSrv.getTooltip(value);
  }
}
